import Header from "components/layout/header";
import Aside from "components/layout/aside";
import Main from "components/layout/main";
import "./layout.scss";

export default function Layout() {
  return (
    <>
      <Header />
      <section className="flex">
        <Aside />
        <Main />
      </section>
    </>
  );
}
